import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { useCSS } from '../../../lib/hooks.js';
import { i18nIntl, convertObjectToArray, getRemotedbUrl, isNotEmpty, removeHTMLTags } from '../../../lib/ep.js';

import ActionLink from '../../builder/ActionLink';
import RawDataViewer from '../../builder/RawDataViewer';
import Tooltip from '../../builder/Tooltip';
import WordCloud from '../../builder/WordCloud';
import Spinner from '../../builder/Spinner.js';
import LeveledHTMLText from '../helpers/LeveledHTMLText.js';
import { InformationMessage } from '../../builder/Message.js';

const AnswerSuboptions = (props) => {
	if(props.suboptions.length == 0) return null;

	const pre_visible = props?.pre_visible ?? false;

	return (
		<ul class={`gui_stats_list is_row gui_suboptions${(pre_visible) ? ' ini_unfolded' : ''}`}>
			{props.suboptions.map((total, t) => {
				let index = t + 1;
				if(index < 10 && props.suboptions.length >= 10) index = `0${index}`;

				const total_people_who_answered = total.num;

				return (
					<li key={t}>
						<p class={`stat_label gui_pos_rel${(isNotEmpty(props, 'bar_class')) ? ` ${props.bar_class}` : ''}`}>
							<span class="gui_cutTextOnOverflow">
								<strong>{total.key}</strong>
								<span class="value gui_not_in_start_small">[{total.percent}%]</span>
							</span>
						</p>

						<ChartRowBar
							width={total.percent}
						/>
					</li>
				)
			})}
		</ul>
	)
};

export const ChartRowBar = (props) => {

	const _style = { width:`${props.width}%` };
	if(props.color)_style['backgroundColor'] = props.color;

	return (
		<span class="bar_guide">
			<Tooltip
				autotranslate={false}
				position="left"
				with_icon={false}
			>{props.tooltip}</Tooltip>

			<span class="bar" style={_style} />
		</span>
	)
};

const QuizStats = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	useCSS('comp/quiz.css');

	const [ display_raw_data, setDisplayRawData ] = useState(false);
	const [ opened_details, setOpenDetails ] = useState(false);
	const [ quiz_stats, setQuizStats ] = useState([]);
	const [ raw_data, setRawData ] = useState({});
	const [ loading, setLoading ] = useState(false);
	const [ delay, setDelay ] = useState(false);
	const [ running, setRunning ] = useState(true);

	const is_builder = props?.builder ?? true;

	useEffect(() => {
		getStageQuizStats(props.stage_id);
	}, [ props.stage_id ]);

	const getStageQuizStats = (stage_id) => {
		setLoading(true);

		let get_stats_url;
		if(stage_id) {
			get_stats_url = `/quizs/stats/${props.promotion_id}/false/${stage_id}`;
		} else {
			get_stats_url = `/quizs/stats/${props.promotion_id}`;
			if(props.user_id != undefined) get_stats_url += `/${props.user_id}`;
		}
		
		$.post(getRemotedbUrl(get_stats_url), (response) => {
			setQuizStats(response.questions);
			setDelay(response?.delay ?? false);
			setRunning(response?.running ?? true);
			setLoading(false);
		}, 'JSON');
	};

	const toggleDetails = (answer_id) => {
		if(answer_id == opened_details) {
			setOpenDetails(false);
		} else {
			setOpenDetails(answer_id);
		}
	};

	const displayRawData = (data) => {
		setDisplayRawData(true);
		setRawData(data);
	};

	if(loading) {
		return (
			<div>
				<Spinner _class={{other:'gui_pos_rel_important'}} force_bg={true}>Loading stats</Spinner>
			</div>
		)
	}
	const display_message_delay = delay && !is_builder && running ? false : false;//No el mostrem mai
	return (
		<div>
			{(is_builder) && (
				<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Share+Tech+Mono&display=swap" media="all" />
			)}

			<ul class={`gui_quiz_stats${(is_builder) ? ' not_awesome gui_not_in_top_huge' : 'public_stats'}`}>
				{quiz_stats.map((q_stats, q) => {
					const question = q_stats.Question;

					return (
						<li key={q} class={`gui_question_stat${(is_builder) ? ' gui_is_padded_hi' : ''}`} style={{ contentVisibility:'auto' }}>
							<LeveledHTMLText>
								<h3 class="question_text"><strong>{removeHTMLTags(question.question)}</strong></h3>
							</LeveledHTMLText>

							{/*<SectionTitle autotranslate={false} _class={{other:'in_top'}}>{question.question}</SectionTitle>*/}

							{/*<SectionSubtitle autotranslate={false}>{i18n("Total answers")}: {(question.total) ? question.total : '0'}</SectionSubtitle>*/}

							<ul>
								{q_stats.Answer.map((a_stats, a) => {
									const answer_type = a_stats.config.type;
									const answer_totals = (a_stats.total) ? convertObjectToArray(a_stats.total) : [];
									let answer_type_icon = '';
									let label_extra = false;
									let display_total_percent = false;
									let display_wordcloud = false;
									let display_suboptions = false;
									let display_suboptions_opened = false;
									switch(answer_type) {
										case 'closed_text':
										case 'image':
											//answer_type_icon = 'knk-button';
											if(a_stats.totalpercent) display_total_percent = true;
											if(question.multiorder) {
												display_suboptions = true;
												label_extra = `[${i18n("Average")}: ${a_stats.avg}]`;
											}
											break;
										case 'rating':
											//answer_type_icon = 'knk-rating';
											display_suboptions = true;

											label_extra = `[${i18n("Average")}: ${a_stats.avg} / ${a_stats.config.star_count} ${i18n("stars")}]`;

											break;
										case 'open_text':
											//answer_type_icon = 'knk-open-text';
											if(a_stats.cloud_text_whole_text != undefined) display_wordcloud = true;
											if(!a_stats.config.text_size && !display_wordcloud) display_suboptions = true;
											break;
										case 'list':
											//answer_type_icon = 'knk-list';
											display_suboptions = true;
											display_suboptions_opened = true;
											break;
									}

									const total_people_who_answered = answer_totals.length > 0 ? answer_totals[0].num:0;

									return (
										<li key={a} class="gui_answer_stat">
											<ul class="gui_stats_list">
												<li class="simple_question">
													{(display_total_percent) && (
														<span class="value with_total">
															<span>{total_people_who_answered}</span>

															<span>({a_stats.totalpercent}%)</span>
														</span>
													)}

													<div class="results">
														<p class={'stat_label ' + answer_type_icon}>
															<span class="gui_pos_rel gui_flexbox gui_flex_align_center" style={{width:'100%'}}>
																<span class="gui_cutTextOnOverflow">
																	{(display_suboptions && !is_builder) ? (
																		<strong>
																			<ActionLink onClick={() => toggleDetails(a_stats.id)} autotranslate={false}>{a_stats.answer_st}<span class="gui_support_sided_icon">[<span class={((opened_details == a_stats.id) ? 'knk-minus' : 'knk-plus')}></span>]</span></ActionLink>
																		</strong>
																	) : (
																		<strong>
																			{a_stats.answer_st}
																			{(label_extra !== false) && (
																				<span class="label_extra">{label_extra}</span>
																			)}
																		</strong>
																	)}
																</span>
															</span>
														</p>

														{(answer_type == 'image' || (answer_type == 'closed_text' && !question.multiorder)) && (
															(answer_totals.map((total, t) => {
																return (
																	<ChartRowBar
																		key={t}
																		tooltip={(!display_total_percent) ? `${total.num} - ${total.percent}%` : null}
																		width={total.percent}
																	/>
																)
															}))
														)}
													</div>

													{(display_wordcloud) && (
														<div class="word_cloud">
															<WordCloud
																words={a_stats.cloud_text_whole_text}
																display_raw_data={displayRawData}
																is_builder={is_builder}
															/>
														</div>
													)}
												</li>
											</ul>

											{(display_suboptions && (opened_details == a_stats.id || is_builder)) && (
												<AnswerSuboptions
													suboptions={answer_totals}
													pre_visible={display_suboptions_opened}
												/>
											)}
										</li>
									)
								})}
							</ul>
						</li>
					)
				})}
			</ul>
			{(display_message_delay) && (
				<InformationMessage
					_class={{ other:'gui_not_in_top_big in_bottom' }}
				>
					<p>{i18n("These results may not be final as this survey is currently receiving many votes. Please check back in a few minutes.")}</p>
				</InformationMessage>
			)}
			{(display_raw_data && is_builder) && (
				<RawDataViewer
					raw_data={raw_data}
					close={()=>setDisplayRawData(false)}
				/>
			)}
		</div>
	)
}

export default injectIntl(QuizStats);